export const drawAreaPreview = (ctx, points, mousePos, controlData) => {
  if (points.length > 1) {
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    for (let i = 1; i < points.length; i++) {
      ctx.lineTo(points[i].x, points[i].y);
    }
    ctx.strokeStyle = controlData.lineColor;
    ctx.lineWidth = controlData.lineWidth;
    ctx.stroke();
  }

  points.forEach((point) => {
    ctx.beginPath();
    ctx.arc(point.x, point.y, 3, 0, 2 * Math.PI);
    ctx.fillStyle = controlData.lineColor;
    ctx.fill();
  });

  if (mousePos.x !== undefined && mousePos.y !== undefined) {
    ctx.beginPath();
    ctx.setLineDash([5, 5]);
    const lastPoint = points[points.length - 1];
    ctx.moveTo(lastPoint.x, lastPoint.y);
    ctx.lineTo(mousePos.x, mousePos.y);
    ctx.strokeStyle = controlData.lineColor;
    ctx.lineWidth = controlData.lineWidth;
    ctx.stroke();
    ctx.setLineDash([]);
  }
};

export const drawArrow = (
  ctx,
  startX,
  startY,
  endX,
  endY,
  lineWidth,
  color
) => {
  const headLength = 20;
  const angle = Math.atan2(endY - startY, endX - startX);

  ctx.beginPath();
  ctx.moveTo(startX, startY);
  ctx.lineTo(endX, endY);
  ctx.lineWidth = lineWidth;
  ctx.strokeStyle = color;
  ctx.stroke();

  ctx.beginPath();
  ctx.moveTo(endX, endY);
  ctx.lineTo(
    endX - headLength * Math.cos(angle - Math.PI / 6),
    endY - headLength * Math.sin(angle - Math.PI / 6)
  );
  ctx.moveTo(endX, endY);
  ctx.lineTo(
    endX - headLength * Math.cos(angle + Math.PI / 6),
    endY - headLength * Math.sin(angle + Math.PI / 6)
  );
  ctx.stroke();
};

export const drawLinePreview = (ctx, points, mousePos, controlData) => {
  if (points.length > 1) {
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    for (let i = 1; i < points.length; i++) {
      ctx.lineTo(points[i].x, points[i].y);
    }
    ctx.strokeStyle = controlData.lineColor;
    ctx.lineWidth = controlData.lineWidth;
    ctx.stroke();
  }

  points.forEach((point) => {
    ctx.beginPath();
    ctx.arc(point.x, point.y, 3, 0, 2 * Math.PI);
    ctx.fillStyle = controlData.lineColor;
    ctx.fill();
  });

  if (mousePos.x !== undefined && mousePos.y !== undefined) {
    ctx.beginPath();
    ctx.setLineDash([5, 5]);
    const lastPoint = points[points.length - 1];
    ctx.moveTo(lastPoint.x, lastPoint.y);
    ctx.lineTo(mousePos.x, mousePos.y);
    ctx.strokeStyle = controlData.lineColor;
    ctx.lineWidth = controlData.lineWidth;
    ctx.stroke();
    ctx.setLineDash([]);
  }
};

export const drawLegend = () => {};
